module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_vm._v("It’s an impossible choice. How am I supposed to make it?")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I think back over the past few weeks and everything that has happened to bring me to this point.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("It doesn’t matter. "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("None")]), _vm._v(" of it matters now.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("All that counts is this choice.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("This impossible choice.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1bacbf5c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/preclude.vue
// module id = 72
// module chunks = 0